document.addEventListener('DOMContentLoaded', function() {
  history.scrollRestoration = 'manual';

  var stickyContainer = document.querySelector('#reviews-sticky');
  var fixedBar = document.querySelector('#reviews-fixed');
  var header = document.querySelector('#shopify-section-header');

  if (!stickyContainer || !fixedBar || !header) {
    return;
  }

  var headerHeight = header.clientHeight;
  var stickyStop = stickyContainer.getBoundingClientRect().top - 121;

  function updateHeaderHeight() {
    headerHeight = header.clientHeight - 1;
  }

  function updateStickyPosition() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= stickyStop) {
      fixedBar.classList.add('is-fixed');
      fixedBar.style.top = headerHeight + 'px';
    } else {
      fixedBar.classList.remove('is-fixed');
      fixedBar.style.top = '0px';
    }
  }

  if (typeof ResizeObserver !== 'undefined') {
    var resizeObserver = new ResizeObserver(function() {
      updateHeaderHeight();
      updateStickyPosition();
    });

    resizeObserver.observe(header);
  }

  window.addEventListener('scroll', updateStickyPosition);
  updateStickyPosition();
});
